module.exports = __webpack_public_path__ + "images/file-type31c5c93b6d970e15559559012a37d435.svg";